import Web1 from "../images/web1.png"
import Web2 from "../images/web2.png"
import Web3 from "../images/web3.png"
import Web4 from "../images/web4.png"
import Web5 from "../images/web5.png"
import Web6 from "../images/web6.png"
const Porto = {
    data : [
        {
            title : "My Own Website",
            image: Web1,
            link: "https://michaeljh.netlify.app/",
            description: "Made and designed by myself"
        },
        {
            title : "Noted",
            image: Web2,
            link: "https://noted-michaeljh.netlify.app/",
            description: "Made and designed by myself"
        },
        {
            title : "STEI 21 Website",
            image: Web3,
            link: "https://stei.netlify.app/database",
            description: "Made the database page"
        },
        {
            title : "IMPACT 2022",
            image: Web4,
            link: "https://impactitb2022.com/registration",
            description: "Made the registration page"
        },
        {
            title : "Jakarta",
            image: Web5,
            link: "https://maikeljh.github.io/jakarta/",
            description: "Made and designed by myself"
        },
        {
            title : "Re-Wear",
            image: Web6,
            link: "https://e-commerce-23.netlify.app/",
            description: "Made by myself"
        },
    ]
}

export default Porto;